import React, { Fragment } from 'react';
import NavbarS3 from "../../components/NavbarS3/NavbarS3"
import HeroSlider from '../../components/HeroSlider/HeroSlider';
import FunFact from '../../components/FunFact/FunFact';
import About from '../../components/about/about';
import CtaSection from '../../components/CtaSection/CtaSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/snbs_logo1.png'
import HeaderTopS3 from '../../components/HeaderTopS3/HeaderTopS3';
import ServiceSectionS3 from '../../components/ServiceSectionS3/ServiceSectionS3';
import CalculationSection from '../../components/CalculationSection/CalculationSection';
import Shape from '../../images/home/img2.png'
import TestimonialS2 from '../../components/TestimonialS2/TestimonialS2';

const HomePage = () => {
    return (
        <Fragment>
           <HeaderTopS3 />
            <NavbarS3 hclass={'wpo-site-header wpo-header-style-3'} Logo={Logo} />
            <HeroSlider />
            <FunFact hclass={'wpo-fun-fact-section-s2'} />
            <About hclass={'wpo-about-section section-padding'} />
             <ServiceSectionS3 hclass={"wpo-service-area-s2 section-padding"} ServiceBtn={true} />
            <CtaSection />
           <TestimonialS2 />
          <CalculationSection hclass={'wpo-calculation-section'} Boy={Shape}/>
            <Footer hclass={'wpo-site-footer'} upperContactArea={true} />
            <Scrollbar />
        </Fragment>
    )
};
export default HomePage;